import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { apiUrl, businessName, businessUserType1, businessUserType2 } from '../../utils/consts';
import { withRouter } from 'react-router';
import moment from 'moment';
import DeleteModal from '../DeleteModal/DeleteModal';
import './styles/adminUsers.scss';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedAdminUsers(props) {

  const { token, userId } = props;

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [users, setUsers] = useState([]);

  // Delete user.
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState();

  // Update User.
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedUserRole, setSelectedUserRole] = useState('USER');
  const [userToUpdate, setUserToUpdate] = useState();
  const [updatingUser, setUpdatingUser] = useState(false);

  // New User.
  const [createFormValidated, setCreateFormValidated] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [creatingUser, setCreatingUser] = useState(false);
  const [birthDate, setBirthDate] = useState();
  const [document, setDocument] = useState('');
  const [role, setRole] = useState('USER');
  const [userType, setUserType] = useState(businessUserType1);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (userToDelete) setShowDeleteModal(true);
  }, [userToDelete]);

  useEffect(() => {
    if (userToUpdate) {
      setShowEditModal(true);
      setSelectedUserRole(userToUpdate.nibiBusinessRole);
    }
  }, [userToUpdate]);

  const filteredUsers = search ? users.filter(item => item.email.toLowerCase().includes(search.toLowerCase())) : users;

  const getData = async () => {
    setLoading(true);

    const usersProm = await fetch(`${apiUrl}/users/admin/get`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const usersResp = await usersProm.json();
    if (usersResp.success) setUsers(usersResp.users);

    setLoading(false);
  };

  const closeUpdateModal = () => {
    setShowEditModal(false);
    setUserToUpdate(null);
    setSelectedUserRole('USER');
    setUpdatingUser(false);
  };

  const closeCreateModal = () => {
    setShowCreateModal(false);
    setCreatingUser(false);
    setCreateFormValidated(false);
    setBirthDate();
    setDocument('');
    setRole('USER');
    setUserType('CEMEX_1');
  };

  const closeDeleteModal = () => {
    setUserToDelete(null);
    setShowDeleteModal(false);
  };

  const deleteUser = async () => {

    if (userToDelete) {
      const deleteProm = await fetch(`${apiUrl}/users/admin/delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          id: userToDelete._id
        })
      });

      const deleteResp = await deleteProm.json();

      if (!deleteResp.success) {
        alert('Ocurrió un error, inténtalo nuevamente.');
      } else {
        alert('Usuario eliminado.');
        getData();
      }

      closeDeleteModal();
    }
  };

  const updateUser = async () => {

    if (userToUpdate) {
      setUpdatingUser(true);

      const updateProm = await fetch(`${apiUrl}/users/admin/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          id: userToUpdate._id,
          nibiBusinessRole: selectedUserRole
        })
      });

      const updateResp = await updateProm.json();

      if (!updateResp.success) {
        alert('Ocurrió un error, inténtalo nuevamente.');
      } else {
        alert('Usuario actualizado.');
        getData();
      }

      closeUpdateModal();
    }
  }

  const createUser = async event => {
    event.preventDefault();
    event.stopPropagation();

    setCreateFormValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {

      setCreatingUser(true);

      const createProm = await fetch(`${apiUrl}/users/admin/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          birthDate,
          document,
          role,
          userType
        })
      });

      const createResp = await createProm.json();

      if (!createResp.success) {
        alert(createResp.message || 'Ocurrió un error, inténtalo nuevamente.');
      } else {
        alert('Usuario creado.');
        getData();
      }

      closeCreateModal();
    }

  };

  if (loading) {
    return (
      <div className="admin-users-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  return (
    <div className="admin-users-component">
      <Container>
        <Row>
          <Col>
            <h1>Usuarios</h1>
            <Row>
              <Form.Group as={Col} sm={4}>
                <Form.Control
                  type="text"
                  value={search}
                  placeholder="Buscar por correo electrónico"
                  onChange={event => setSearch(event.target.value)}
                />
              </Form.Group>
              <Col sm={4}></Col>
              <Col sm={4}>
                <Button className="app-button" style={{ width: '100%', maxWidth: '250px', float: 'right' }} onClick={() => setShowCreateModal(true)}>
                  Crear usuario
                </Button>
              </Col>
            </Row>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Email</th>
                  <th>Nombre</th>
                  <th>Apellido</th>
                  <th>Identificación</th>
                  <th>Fecha de creación</th>
                  <th>Rol</th>
                  <th>Tipo</th>
                  <th style={{ textAlign: 'center' }}>Opciones</th>
                </tr>
              </thead>
              <tbody>
                {
                  filteredUsers.map((user, index) =>
                    <tr key={user._id}>
                      <td>{index + 1}</td>
                      <td>{user.email}</td>
                      <td>{user.firstName}</td>
                      <td>{user.lastName}</td>
                      <td>{user.identification}</td>
                      <td>{moment(user.dateCreated).format('YYYY-MM-DD')}</td>
                      <td>{user.nibiBusinessRole === 'ADMIN' ? 'Administrador' : 'Usuario'}</td>
                      <td>{user.nibiBusinessUserType}</td>
                      <td>
                        <div style={{ display: 'block', margin: '0 auto', width: 'fit-content' }}>
                          <i className="fas fa-edit" onClick={() => setUserToUpdate(user)} />
                          <i className="fas fa-trash-alt delete-icon" onClick={() => setUserToDelete(user)} />
                        </div>
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>

      <DeleteModal
        show={showDeleteModal}
        text={userToDelete ? `el usuario ${userToDelete.email}` : ''}
        onClose={closeDeleteModal}
        onDelete={deleteUser}
      />

      <Modal show={showEditModal} onHide={closeUpdateModal}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {
            userToUpdate &&
            <>
              <p>Editar el usuario {userToUpdate.email}</p>
              <Form>
                <Form.Row>
                  <Form.Group as={Col} xs={6}>
                    <Form.Label>Rol del usuario</Form.Label>
                    <Form.Control
                      as="select"
                      value={selectedUserRole}
                      onChange={event => setSelectedUserRole(event.target.value)}
                    >
                      <option value="USER">Usuario</option>
                      <option value="ADMIN">Administrador</option>
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
              </Form>
            </>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" onClick={updateUser} disabled={updatingUser}>
            {
              updatingUser ? <Spinner variant="warning" size="sm" animation="border" /> : 'Guardar cambios'
            }
          </Button>
          <Button variant="secondary" onClick={closeUpdateModal}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showCreateModal} onHide={closeCreateModal} size="lg">
        <Modal.Header closeButton></Modal.Header>
        <Form onSubmit={createUser} noValidate validated={createFormValidated}>
          <Modal.Body>
            <Form.Row>
              <Form.Group as={Col} sm={6}>
                <Form.Label>Fecha de nacimiento</Form.Label>
                <Form.Control
                  type="date"
                  value={birthDate}
                  onChange={event => setBirthDate(event.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group as={Col} sm={6}>
                <Form.Label>Documento</Form.Label>
                <Form.Control
                  type="text"
                  value={document}
                  onChange={event => setDocument(event.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group as={Col} sm={6}>
                <Form.Label>Rol</Form.Label>
                <Form.Control
                  as="select"
                  value={role}
                  onChange={event => setRole(event.target.value)}
                >
                  <option value="USER">Usuario</option>
                  <option value="ADMIN">Administrador</option>
                </Form.Control>
              </Form.Group>

              <Form.Group as={Col} sm={6}>
                <Form.Label>Tipo</Form.Label>
                <Form.Control
                  as="select"
                  value={userType}
                  onChange={event => setUserType(event.target.value)}
                >
                  <option value={businessUserType1}>{businessUserType1}</option>
                  <option value={businessUserType2}>{businessUserType2}</option>
                </Form.Control>
              </Form.Group>

            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="info" type="submit" disabled={creatingUser}>
              {
                creatingUser ? <Spinner variant="warning" size="sm" animation="border" /> : 'Guardar'
              }
            </Button>
            <Button variant="secondary" onClick={closeCreateModal}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

    </div>
  );
}

const AdminUsers = connect(select)(ConnectedAdminUsers);

export default withRouter(AdminUsers);
